import React from 'react';
import styled from 'styled-components';
import { useTheme, useThemeColor } from '../context/ThemeContext';

const StyledText = styled.div`
  color: ${props => props.textColor};
  font-size: ${props => props.fontSize};
  line-height: ${props => props.lineHeight};
  font-weight: ${props => props.fontWeight};
  ${props => props.customStyles}
`;

const typeStyles = {
  default: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400'
  },
  defaultSemiBold: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '600'
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    lineHeight: '32px'
  },
  subtitle: {
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '24px'
  },
  link: {
    fontSize: '16px',
    lineHeight: '30px',
    fontWeight: '400',
    color: '#59caee'
  },
  small: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: '400'
  },
  large: {
    fontSize: '18px',
    lineHeight: '28px',
    fontWeight: '400'
  }
};

export const ThemedText = ({
  children,
  lightColor,
  darkColor,
  type = 'default',
  style,
  className,
  as = 'div',
  ...otherProps
}) => {
  const { colors } = useTheme();
  const textColor = useThemeColor(
    { light: lightColor, dark: darkColor },
    'text'
  );

  const typeStyle = typeStyles[type] || typeStyles.default;

  // For link type, use the predefined color unless overridden
  const finalColor = type === 'link' && !lightColor && !darkColor
    ? colors.tint
    : textColor;

  return (
    <StyledText
      as={as}
      textColor={finalColor}
      fontSize={typeStyle.fontSize}
      lineHeight={typeStyle.lineHeight}
      fontWeight={typeStyle.fontWeight}
      customStyles={style}
      className={className}
      {...otherProps}
    >
      {children}
    </StyledText>
  );
};